{
    "AddNotification": "Benachrichtigung hinzufügen",
    "EditNotification": "Benachrichtigung bearbeiten",
    "EnableNotification": "Benachrichtigung einschalten",
    "DisableNotification": "Benachrichtigung deaktivieren",
    "NotificationNameBusyTime": "Vielbeschäftigte Zeit",
    "NotificationNameAvgAnswerTime": "Durchschnittliche Antwortzeit (Sekunden)",
    "NotificationNameUserNotLoggedIn7Days": "Benutzer nicht eingeloggt 7 Tage",
    "NotificationNameMissedCalls": "Verpasste Anrufe (#)",
    "NotificationNameUserNeverLoggedIn": "Niemals eingeloggt",
    "NotificationNameWeeklyInsightsReport": "Wöchentlicher Insights-Bericht",
    "NAME": "NotificationsLanguage"
}